// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyAFVxb6nxvSOwh08SkOco2ZT9iQFhMjz7g",
    authDomain: "",
    databaseURL: "",
    projectId: "sandoz-ac745",
    storageBucket: "",
    messagingSenderId: "956618987678",
    appId: "1:956618987678:web:4dad39b54affcab6f8c38f"
  }

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
